<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert } from '@Shelly/shelly-design-system';

	const browser = /chrome[ /]([\w.]+)/i.exec(navigator.userAgent)?.[1];
	const browsers_list = 'Chrome, Edge, Opera, Samsung Internet';
	const linkDocsSupport = 'https://www.bluetooth.com/blog/the-web-bluetooth-series/';
	// const linkDocsSupportBackup = 'https://developer.chrome.com/docs/capabilities/bluetooth';
</script>

<Alert
	type={browser ? 'info' : 'warning'}
	heading={$format('alert_title_ble_pair_not_supported', {
		default: 'Your browser does not support Bluetooth pairing!',
	})}
	message={browser
		? $format('alert_message_ble_pair_not_supported_enable_experimental', {
				default:
					'For Linux and earlier versions of Windows, to use this feature, please enable the about://flags/#enable-experimental-web-platform-features flag.',
			})
		: $format('alert_message_ble_pair_not_supported', {
				values: { browsers_list },
				default:
					'We are sorry, but your browser does not support Bluetooth pairing. Supported browsers are: {browsers_list}.',
			})}
	cta={{
		title: $format('link_learn_more', {
			default: 'Find out more here',
		}),
	}}
	on:cta_click={() => window.open(linkDocsSupport, '_blank')}
/>
